import { isMobile } from '../../../../core/helpers/isMobile';

export const noWinSymbol = 1;

export const iconStates = {
  win: 'win',
  idle: 'idle',
  blur: 'blur',
};

export const symbolEnum = {
  medusa: 0,
  hermes: 1,
  ares: 2,
  afrodita: 3,
  zeus: 4,
  x100: 5,
  x200: 6,
  X300: 7,
  x400: 8,
  X500: 9,
  X550: 10,
};

export const symbolValueEnum = {
  0: 'medusa',
  1: 'hermes',
  2: 'ares',
  3: 'aphrodite',
  4: 'zeus',
};

export const reelParams = {
  visibleRows: 1,
  iconsInReel: 7,
  iconsHeight: isMobile() ? 126 : 278,
  iconsWidth: isMobile() ? 126 : 278,
  finalPositionX: 0,
  finalPositionY: 0,
  iconsSpacing: 0,
  spacing: isMobile() ? 6 : 10,
  iconMargins: { default: 98 },
  offsetForContainerBoardWidth: isMobile() ? 0 : 0,
  loopDuration: 0.7,
  stretchDuration: 1.5,
  finalStopPositionY: 0,
  stretchStepDurations: [1, 5, 10, 20, 30, 40],
  iconsFinalPositions: {
    inWinContainer: [],
    inReel: [],
  },
};

export const reelContainerParams = {
  width: isMobile() ? 126 : 278,
  height: isMobile() ? 126 : 278,
  xInFigma: isMobile() ? 325 : 704,
  yInFigma: isMobile() ? 104 : 407,
};

export const reelSymbolNames = {
  zeus: 'zeus',
  aphrodite: 'aphrodite',
  ares: 'ares',
  hermes: 'hermes',
  medusa: 'medusa',
  x100: 'x100',
  x200: 'x200',
  x300: 'x300',
  x400: 'x400',
  x500: 'x500',
  x550: 'x550',
};

export const reelSymbolIndexesConfig = {
  standard: [0, 4],
  bonus: [5, 10],
};

export const stageSizes = {
  width: isMobile() ? 359 : 1028,
  height: isMobile() ? 307 : 680,
};
